import {
  DirectionTypeEnum,
  MessageConversationSubscription,
  MessageConversationTypeEnum,
} from '@/types/generated/graphql';

export function shouldOpenNewConversation({
  clientId,
  channelId,
  data,
}: {
  clientId: string;
  channelId: string;
  data: MessageConversationSubscription;
}): boolean {
  const isNewConversationPage = clientId === 'new';
  const isOutgoingCall =
    data?.messageConversation?.conversationType === MessageConversationTypeEnum.conference &&
    data?.messageConversation?.direction === DirectionTypeEnum.outgoing;
  const isSameChannel = data?.messageConversation?.channelId === +channelId;

  return isNewConversationPage && isOutgoingCall && isSameChannel && !!data?.messageConversation?.client?.id;
}

export function openNewConversationHandler({
  clientId,
  channelId,
  data,
  search,
  navigate,
}: {
  clientId: string;
  channelId: string;
  data: MessageConversationSubscription;
  search: string;
  navigate: (to: { pathname: string; search?: string }) => void;
}) {
  if (!shouldOpenNewConversation({ clientId, channelId, data })) return;

  navigate({
    pathname: `/conversations/${channelId}/${data.messageConversation?.client?.id}`,
    search,
  });
}
